import React, { createContext, useEffect, useState } from "react";

export const AddToMyListContext = createContext();

const AddToMyListContextProvider = (props) => {
  const [addedBookmark, setAddedBookmark] = useState(false);
  const [removedBookmark, setRemovedBookmark] = useState(false);

  const addedBookmarkStyle = { animation: "addToList 1s" };
  const removedBookmarkStyle = { animation: "removeFromList 1s" };

  const [currentAnimation, setCurrentAnimation] = useState();

  const updateAddedBookmark = () => {
    setCurrentAnimation(null);
    setAddedBookmark(true);
  };

  const updateRemovedBookmark = () => {
    setCurrentAnimation(null);
    setRemovedBookmark(true);
  };

  useEffect(() => {
    if (addedBookmark) {
      setCurrentAnimation(addedBookmarkStyle);
      setAddedBookmark(false);
    }
  }, [addedBookmark]);

  useEffect(() => {
    if (removedBookmark) {
      setCurrentAnimation(removedBookmarkStyle);
      setRemovedBookmark(false);
    }
  }, [removedBookmark]);

  return (
    <AddToMyListContext.Provider
      value={{
        addedBookmark,
        updateAddedBookmark,
        removedBookmark,
        updateRemovedBookmark,
        currentAnimation,
      }}
    >
      {props.children}
    </AddToMyListContext.Provider>
  );
};

export default AddToMyListContextProvider;
